import theme from 'src/theme';
import styled from 'styled-components';

export const PageContentWrapper = styled.div`
    display: grid;
    grid-template-columns: 300px minmax(0, 1fr);
    height: calc(100% - 5px);
    max-width: 100%;
    grid-gap: 5px;
    padding: 0 5px;
`;

export const LeftWrapper = styled.div`
    box-shadow: #ccc 0 2px 6px 2px;
    height: 100%;
    overflow: hidden;
`;

export const MainPanel = styled.div`
    position: relative;
    height: 100%;
    overflow: hidden;
    box-shadow: #ccc 0 2px 6px 2px;
    background-color: ${theme.legacyColors.greyBackground};
`;
